import { api } from "./api";
import type { Result } from "./spec";

/**
 * The Pulse: platform-wide figures the server computed from its own stores.
 *
 * Spec-derived, and null-narrowed like every `api.*` result: a figure the server
 * could not compute (`null` on the wire) is simply absent here, so "absent" and
 * "below the Disclosure floor" read the same to a caller.
 */
export type Pulse = Result<"pulse", "get">;
export type PulseInstitution = Pulse["institutions"][number];

const pulseService = {
  /** Public: no bearer. A 503 (no snapshot yet) rejects like any other error. */
  getPulse: () => api.get("pulse", {}),
};

export default pulseService;
